import type { LegalSection } from '../../content/legal/legalMeta';
import { LegalPageLayout } from './LegalPageLayout';
import { LegalSectionView } from './LegalSectionView';

export type LegalDocumentPageProps = {
  title: string;
  sections: LegalSection[];
};

export function LegalDocumentPage({ title, sections }: LegalDocumentPageProps) {
  return (
    <LegalPageLayout title={title}>
      {sections.map((section) => (
        <LegalSectionView key={section.id} section={section} />
      ))}
    </LegalPageLayout>
  );
}
